module.exports = __webpack_public_path__ + "img/_6.889a0006.png";